import infrastructureMapBuilder from "./infrastructure_map_builder";
import tariffSurveyMapBuilder from "./tariff_survey_map_builder";

const leafletBuilder = function (leafletHtmlID, leafletApiKey, mapOptions) {
  const builderFunctionName = mapOptions.builder_function;

  if (builderFunctionName === "infrastructureMapBuilder") {
    infrastructureMapBuilder(leafletHtmlID, leafletApiKey, mapOptions.markers);
  } else if (builderFunctionName === "tariffSurveyMapBuilder") {
    tariffSurveyMapBuilder(leafletHtmlID, mapOptions);
  }
};

export default leafletBuilder;
